// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"023a9582","667":"7ea88c6c","977":"dc9391f1"}[chunkId] + ".chunk.js";
};